<template>
  <div id="about" class="franchise-main flex flex-space-between mt-70">
    <div class="franchise-main-wrapper public-container-mobile">
      <h2>{{ data.title }}</h2>
      <div>{{ data.description }}</div>
      <h2 class="mt-60">{{ data.listTitle }}</h2>
      <ul class="public-list public-list-square">
        <li v-for="text in data.list.split(';')">
          <span>{{ text }}</span>
        </li>
      </ul>
      <vz-button
        large
        variant="primary"
        class="mt-60"
        :to="{ hash: '#franchise-offer-block' }"
      >
        Оставить заявку
      </vz-button>
    </div>
    <div class="franchise-main-img">
      <NuxtImg src="/images/pages/franchise/main.png" alt="" format="webp" loading="lazy" />
      <div class="franchise-main-img-wrapper">
        <div v-for="item in items">
          <span>{{ item.count }}</span>
          {{ item.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {getPageContent} from '~/api/content';

const data = (await getPageContent('/franchise')).blocks?.about

const items = [
  {
    count: '4',
    text: 'Страны'
  },
  {
    count: '130 000+',
    text: 'Населенных пунктов'
  },
  {
    count: '1000+',
    text: 'Городов доставки'
  },
  {
    count: '80+',
    text: 'Терминалов'
  },
  {
    count: '70+',
    text: 'Торговых сетей'
  }
]
</script>
